import { Controller } from "react-hook-form";
import clsx from "clsx";
import { TbHandClick } from "react-icons/tb";
import { FaCheckCircle } from "react-icons/fa";
import PropTypes from "prop-types";

const InputField = ({
  id,
  label,
  placeholder,
  control,
  rules = {},
  error,
  errorMessages = {},
  disabled = false,
  type = "text",
  className = "",
  accept,
  defaultValue,
  helperText, // 👈 NUEVO
}) => {
  const errorMessage = error?.type ? errorMessages[error.type] : null;
  const isFile = type === "file";

  return (
    <div className={clsx("group flex w-full flex-col", className)}>
      <label
        htmlFor={id}
        className="mb-1 text-sm font-medium text-gray-700 group-has-[input[aria-invalid=true]]:text-red-500"
      >
        {label}
      </label>

      <div
        className={clsx(
          "flex items-center rounded-lg border border-gray-300 bg-white px-3 py-2",
          "group-has-[input:disabled]:bg-gray-100",
          "group-has-[input[aria-invalid=true]]:border-red-500",
        )}
      >
        <Controller
          name={id}
          control={control}
          rules={rules}
          defaultValue={defaultValue}
          render={({ field: { onChange, value, ...field } }) => {
            if (isFile) {
              const handleFileChange = async (e) => {
                const file = e.target.files?.[0];
                if (file) {
                  const reader = new FileReader();
                  reader.onloadend = () => {
                    onChange(reader.result);
                  };
                  reader.readAsDataURL(file);
                } else {
                  onChange(null);
                }
              };

              return (
                <div className="w-full">
                  <label
                    htmlFor={id}
                    className="flex cursor-pointer items-center gap-4 hover:underline"
                  >
                    {value ? <FaCheckCircle /> : <TbHandClick />}
                    {value
                      ? "Archivo cargado correctamente"
                      : "Seleccionar archivo"}
                  </label>
                  <input
                    id={id}
                    type="file"
                    accept={accept}
                    disabled={disabled}
                    aria-invalid={!!error}
                    onChange={handleFileChange}
                    className="hidden"
                    {...field}
                  />
                </div>
              );
            }

            return (
              <input
                id={id}
                placeholder={placeholder}
                type={type}
                disabled={disabled}
                value={value}
                onChange={onChange}
                aria-invalid={!!error}
                className="peer ml-2 flex-1 bg-transparent outline-none"
                {...field}
              />
            );
          }}
        />
      </div>

      {/* 🔥 MENSAJES */}
      {helperText && (
        <span className="mt-1 text-xs text-slate-400">{helperText}</span>
      )}
      {errorMessage && (
        <span className="text-xs text-red-500">{errorMessage}</span>
      )}
    </div>
  );
};

export default InputField;

InputField.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  accept: PropTypes.string,
  placeholder: PropTypes.string,
  control: PropTypes.object.isRequired,
  rules: PropTypes.object,
  error: PropTypes.object,
  errorMessages: PropTypes.object,
  disabled: PropTypes.bool,
  type: PropTypes.string,
  className: PropTypes.string,
  helperText: PropTypes.string, // 👈 NUEVO
};
